import * as React from "react";
import { useTl, useApiService, useAbortableApiServiceFactory } from "../../../../../hooks";
import { useHistory } from "react-router";
import {
  TitrePedagogiqueApi,
  FcbTitrePedagogiqueDto,
  TitrePedagogiqueSearch,
  EBooleanSearchTypes
} from "../../../../../api";
import { ViewButton, EditButton, SearchTablePage } from "../../../../../components";
import { ERoutes } from "../../../../../AppRouter";
import { ETLCodes } from "../../../../../locales";
import styled from "styled-components";

interface ITitrePedagogiqueListPageProps {}
const Container = styled.div`
  display: flex;
`;
export const TitrePedagogiqueListPage: React.FunctionComponent<ITitrePedagogiqueListPageProps> = () => {
  const { t } = useTl();
  const history = useHistory();
  const api = useApiService(TitrePedagogiqueApi);

  const columns = React.useMemo(
    () => [
      {
        computed: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: FcbTitrePedagogiqueDto) => (
          <Container>
            <ViewButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.titrePedagogique}/${row.idtitre}/detail/view`)}
            />
            <EditButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.titrePedagogique}/${row.idtitre}/detail/edit`)}
            />
          </Container>
        )
      },
      {
        header: () => t(ETLCodes.Libelle),
        fieldName: "libelle"
      }
    ],
    [history, t]
  );

  const onAddItem = React.useCallback(() => {
    history.push(`${ERoutes.titrePedagogique}/0/detail/edit`);
  }, [history]);

  const getCriteriasFn = React.useCallback(() => api.titrePedagogiqueGetSearchCriterias({ includeListsValues: true }), [
    api
  ]);

  const apiFactory = useAbortableApiServiceFactory(TitrePedagogiqueApi);
  const lastAbortController = React.useRef<AbortController>();
  const searchFn = React.useCallback(
    (sObj?: TitrePedagogiqueSearch) => {
      const { api: abortableApi, abortController } = apiFactory();
      lastAbortController.current = abortController;
      return abortableApi.titrePedagogiqueBaseSearch({ TitrePedagogiqueSearch: sObj });
    },
    [apiFactory]
  );

  const onAbort = React.useCallback(() => lastAbortController.current?.abort(), []);

  return (
    <SearchTablePage
      getCriteriasFunction={getCriteriasFn}
      searchFunction={searchFn}
      onAbort={onAbort}
      columns={columns}
      breadCrumbs={[{ text: t(ETLCodes.TitresPedagogiques), route: ERoutes.titrePedagogique }]}
      addFunc={onAddItem}
      sortKeys={{ libelle: "ASC" }}
      defaultCriterias={[
        {
          criteria: "Actif",
          searchMode: EBooleanSearchTypes.Equals,
          value: true
        }
      ]}
    />
  );
};
